export const textInputStyle = `appearance: none`;
